<template>
  <div class="nav">
    <span @click="setParentNavList('init')" v-if="title" class="allFilee">全部文件</span>
    <span v-else class="allFilei">全部文件</span>
    <span v-for="(item, index) in parentNavList" :key="index">
      <span class="file"> > </span>
      <span @click="setParentNavList('slice', item, index)" class="fileSymbol">···</span>
    </span>
    <span class="file" v-if="title"> > </span>
    <span class="title">{{ title }}</span>
  </div>
</template>

<script setup>
import './index.scss';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  parentNavList: Array,
  title: String,
});
const emit = defineEmits(['setParentNavList']);
function setParentNavList(...params) {
  emit('setParentNavList', ...params);
}
</script>
